import { useCallback, useEffect, useState } from 'react';
import type { AbilitySnapshot } from '@examflow/api';
import { api } from '../../lib/api';

export type AbilitySnapshotsStatus = 'loading' | 'ready' | 'unavailable';

export function useAbilitySnapshots({
  userId,
  examType,
  limit = 20,
  refreshKey,
}: {
  userId?: string | null;
  examType?: string | null;
  limit?: number;
  refreshKey?: number | string;
}) {
  const [snapshots, setSnapshots] = useState<AbilitySnapshot[]>([]);
  const [status, setStatus] = useState<AbilitySnapshotsStatus>('loading');

  const loadSnapshots = useCallback(async () => {
    if (!userId || !examType) {
      setSnapshots([]);
      setStatus('unavailable');
      return;
    }

    setStatus('loading');

    try {
      const { snapshots: nextSnapshots } = await api.learning.getAbilitySnapshots({
        examType,
        limit,
      });
      setSnapshots(nextSnapshots);
      setStatus('ready');
    } catch {
      setSnapshots([]);
      setStatus('unavailable');
    }
  }, [userId, examType, limit]);

  useEffect(() => {
    void loadSnapshots();
  }, [loadSnapshots, refreshKey]);

  return {
    snapshots,
    status,
    reload: loadSnapshots,
  };
}
